/**
 * FormuLář vybrání jednoho subjektu z více, které byly na základě vyhledávání vráceny ze ZR.
 */
import React from 'react';
import {connect} from 'react-redux';
import {ff, field, form} from './../index';
import {formValueSelector, reduxForm} from 'redux-form';
import SubjektRow from "./SubjektRow";

class SubjektAddSelectRegForm extends React.Component {
    static formName = 'subjektAddSelectRegForm';

    static PropTypes = {
        //overeniResultList
    };

    static defaultProps = {};

    render() {
        const {subjekt, onClose, handleSubmit, overeniResultList} = this.props;

        return (
            <form.Form onSubmit={handleSubmit} horizontal>
                <form.FormBody>
                    <ff.ListSelect
                        name="subjekt"
                        field={false}
                        idAttrName="overeniId"
                        renderItem={x => <SubjektRow subjekt={x.subjekt} zastupce={x.subjekt.zastupce} />}
                        items={overeniResultList}
                    />
                </form.FormBody>
                <form.FormActions submitButton="Vybrat" cancelButton submitDisabled={!subjekt} onClose={onClose} />
            </form.Form>
        )
    }
}

const reduxSubjektForm = reduxForm({
    form: SubjektAddSelectRegForm.formName
})(SubjektAddSelectRegForm);

function mapStateToProps(state, props) {
    const selector = formValueSelector(SubjektAddSelectRegForm.formName);
    return {
        subjekt: selector(state, "subjekt"),
    };
}

export default connect(mapStateToProps)(reduxSubjektForm)
